import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { Save } from 'lucide-react';

const TEXT_POSITIONS = [
  { value: '0', label: 'Сверху' },
  { value: '1', label: 'Справа' },
  { value: '2', label: 'Снизу' },
  { value: '3', label: 'Слева' },
];

export function AddPSSheet({ title, initialNumber = '', initialTextPosition = 0, onClose, onSave }) {
  const [number, setNumber] = useState(initialNumber);
  const [position, setPosition] = useState(String(initialTextPosition));

  return (
    <BottomSheet title={title} onClose={onClose} open={true} modal={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* Номер ПС */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Номер ПС
          </label>
          <input
            type="text"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="Введите номер ПС"
            style={{
              width: '100%',
              padding: '12px 16px',
              fontSize: '15px',
              border: '1px solid #e5e5e5',
              borderRadius: '12px',
              background: '#f9f9f9',
              boxSizing: 'border-box',
              outline: 'none'
            }}
          />
        </div>

        {/* Расположение номера */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Расположение номера
          </label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {TEXT_POSITIONS.map((pos) => (
              <button
                key={pos.value}
                onClick={() => setPosition(pos.value)}
                style={{
                  padding: '12px',
                  borderRadius: '12px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  background: position === pos.value ? '#3b82f6' : '#f5f5f5',
                  color: position === pos.value ? 'white' : '#1a1a1a',
                  transition: 'all 0.15s'
                }}
              >
                {pos.label}
              </button>
            ))}
          </div>
        </div>

        {/* Кнопка сохранить */}
        <button
          onClick={() => onSave(number, parseInt(position))}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '16px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <Save size={18} />
          Сохранить
        </button>

      </div>
    </BottomSheet>
  );
}